import React, { useEffect, useState, useContext } from "react"
import PropTypes from "prop-types"
import { Link, useParams } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import ReactImageMagnify from "react-image-magnify"
import { formatNumberWithCommas } from "../../common/utility"
import { Button, Card, Col, Container, Row, Input } from "reactstrap"
import { isEmpty } from "lodash"
import Breadcrumbs from "components/Common/Breadcrumb"
import { getProductDetail } from "http/products/products"
import { CartContext } from "context/cartContext"
import { WishlistContext } from "context/wishlistContext"
import ToastDialog from "components/Common/ToastDialog"
import { Lightbox } from "components/LightBox"
import moment from "moment"

const EcommerceProductDetail = props => {
  document.title = "Product Details | DMS"
  const [selectedQuantity, setSelectedQuantity] = useState(0)
  const [product, setProduct] = useState(null)
  const user = JSON.parse(localStorage.getItem("user"))
  const roleName = user.roleName
  const { getCartData, addItemToCart, cartItems } = useContext(CartContext)
  const { wishlistItems, getWishlistData, addItemToWishList } =
    useContext(WishlistContext)
  const [toastInfo, setToastInfo] = useState({ showToast: false })
  const params = props.router.params
  const [currentProductImage, setCurrentProductImage] = useState(0)
  const [lightbox, setLightbox] = useState(false)
  const [imageExists, setImageExists] = useState(false); 
  const [categoryList, setCategoryList] = useState([])
  const [subCategoryList, setSubCategoryList] = useState([])
  const [modelList, setModelList] = useState([])


  useEffect(() => {
    fetchProductDetail()
  }, [params])

  const fetchProductDetail = async () => {
    const productId = params && params.id ? parseInt(params.id) : 1
    let res = await getProductDetail({ id: productId})
    if (res.status) {
      setProduct(res.data[0])
      let categoryArr=[];
      let subCategoryArr=[];
      let modelArr=[];
      let productData = res.data[0].productMappings;
      productData.forEach((elem,index)=>{
        if(!categoryArr.includes(elem.category.category_name)){
          categoryArr.push(elem.category.category_name)
        }
        if(!subCategoryArr.includes(elem.subCategory.sub_category_name)){
          subCategoryArr.push(elem.subCategory.sub_category_name)
        }
        if(!modelArr.includes(elem.model.model_name)){
          modelArr.push(elem.model.model_name)
        }
      })

      setCategoryList(categoryArr);
      setSubCategoryList(subCategoryArr);
      setModelList(modelArr);
      
      setSelectedQuantity(res?.data?.[0]?.minQty || 0)
      fetchCartList()
      fetchWishlist()
    }
  }

  const backButton = () => {
    window.history.back()
  }

  const fetchCartList = async () => {
    try {
      await getCartData()
    } catch (e) {
      setToastInfo({
        message: e.message,
        showToast: true,
        role: "error",
      })
    }
  }

  const fetchWishlist = async () => {
    try {
      await getWishlistData()
    } catch (e) {
      setToastInfo({
        message: e.message,
        showToast: true,
        role: "error",
      })
    }
  }

  const addToCart = async (id,minQty,maxQty,lotSize) => {
    try {
      if (selectedQuantity) {
        const addedToCart= await addItemToCart({
          productId: id,
          quantity: selectedQuantity,
          minQty,
          maxQty,
          lotSize
        })
        if(addedToCart.status){
          setToastInfo({
            message: "Product added to cart successfully",
            showToast: true,
            role: "success",
          })
          fetchCartList()
          setSelectedQuantity(minQty ||0)
          fetchProductDetail()
        }else{
          setToastInfo({
            message: addedToCart.message,
            showToast: true,
            role: "error",
          })
          setSelectedQuantity(minQty || 0)
        }
      } else {
        setToastInfo({
          message: "Please select quantity",
          showToast: true,
          role: "error",
        })
        setSelectedQuantity(minQty ||0)
      }
    } catch (e) {
      setToastInfo({
        message: e.message,
        showToast: true,
        role: "error",
      })
      setSelectedQuantity(minQty ||0)
    }
  }

  const addToWishlist = async id => {
    try {
      await addItemToWishList({
        productId: id,
      })
      setToastInfo({
        message: "Product added to wishlist successfully",
        showToast: true,
        role: "success",
      })
      fetchWishlist()
      fetchProductDetail()
    } catch (e) {
      setToastInfo({
        message: e.message,
        showToast: true,
        role: "error",
      })
    }
  }

  let productWithInfo = {
    ...product,
    isInCart: cartItems?.some(item => item.product.id === product?.id),
    isInWishList: wishlistItems?.some(item => item.product.id === product?.id),
  }

  useEffect(() => {
    const imgSrc = process.env.REACT_APP_IMAGE_URL + product?.productImages[currentProductImage]?.image?.paths.original;
    const img = new Image();
    img.src = imgSrc;
    img.onload = () => setImageExists(true);
    img.onerror = () => setImageExists(false);
  }, [product, currentProductImage]);

  return (
    <>
      <div className="page-content mb-3">
        <Container fluid>
          <Breadcrumbs title="Ecommerce" breadcrumbItem="Product Detail" />
          {!isEmpty(product) && (
            <Row>
              <Col>
                <Row className="mb-2">
                <Col xl={6}>
                    <div className="product-detai-imgs">
                      <Card style={{ marginRight: "30px" }}>
                        {
                          imageExists ? (
                            <ReactImageMagnify
                              {...props}
                              {...{
                                smallImage: {
                                  alt: "Wristwatch by Ted Baker London",
                                  isFluidWidth: true,
                                  src:
                                    process.env.REACT_APP_IMAGE_URL +
                                    product?.productImages[currentProductImage]?.image
                                      ?.paths.original,
                                },
                                largeImage: {
                                  src:
                                    process.env.REACT_APP_IMAGE_URL +
                                    product?.productImages[currentProductImage]?.image
                                      ?.paths.original,
                                  width: 1500,
                                  height: 1500,
                                },
                                enlargedImageContainerStyle: {
                                  zIndex: "20",
                                  backgroundColor: "white",
                                },
                                enlargedImageContainerDimensions: {
                                  width: "120%",
                                  height: "110%",
                                },
                                
                              }}
                              style={{ cursor: "zoom-in" }}
                              onClick={() =>
                                window.innerWidth > 768 && setLightbox(true)
                              }
                            />
                          ) : (
                            <div
                              style={{
                                cursor: "pointer",
                                width: '100%',
                                height: '433px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                // border: '1px solid #ced4da'
                              }}
                            >
                              <img
                                src={
                                  "/no-image.png"
                                }
                                alt=""
                                className="img-fluid mx-auto d-block"
                                style={{
                                  // height: "10rem",
                                  width: '10rem'
                                }}
                                onClick={() => {
                                  navigate(
                                    `/${roleName === "dealer"
                                      ? "customer"
                                      : roleName
                                    }/product-detail/${product.id}`
                                  )
                                }}
                              />
                            </div>
 
                          )
                        }
                      </Card>
 
                      <div
                        style={{ justifyContent: "center" }}
                        className="mt-3 thumbnail-wrapper d-flex"
                      >
                        {[0, 1, 2, 3, 4].map(index => (
                          <>
                            {product?.productImages[index]?.image.paths
                              .original && (
                                <div
                                  key={index}
                                  className={`thumbnail ${currentProductImage === index ? "active" : ""
                                    }`}
                                  style={{ position: "relative" }}
                                  onClick={() => setCurrentProductImage(index)}
                                >
                                  <img
                                    src={
                                      process.env.REACT_APP_IMAGE_URL +
                                      product?.productImages[index]?.image?.paths
                                        ?.original
                                    }
                                    alt={`thumbnail-${index}`}
                                    style={{
                                      transform:
                                        currentProductImage === index
                                          ? "scale(1.2)"
                                          : "scale(1)",
                                      transition: "transform 0.3s ease-in-out",
                                      boxShadow:
                                        currentProductImage === index
                                          ? "0 0 15px rgba(0, 0, 0, 0.2)"
                                          : "0 0 5px rgba(0, 0, 0, 0.1)",
                                      border:
                                        currentProductImage === index
                                          ? "2px solid #3498db"
                                          : "none",
                                    }}
                                    onError={(e) => {
                                      e.target.onerror = null; // Prevents infinite looping if default image also fails to load
                                      e.target.src='/no-image.png';
                                     e.target.style.display='none'
                                    }}
                                  />
                                </div>
                              )}
                          </>
                        ))}
                      </div>
                    </div>
                  </Col>

                  <Col xl="6">
                    <div className="mt-4 mt-xl-3 mb-4">
                      <span className="text-muted" style={{ color: "#7B8788" }}>
                        {categoryList.join(', ')} {"/"}{" "}
                        {subCategoryList.join(', ')}
                      </span>
                      <h4 className="mt-1 mb-2">{product?.productName}</h4>
                      {roleName === "dealer" && (
                        <div className="d-flex">
                          <b className="me-2 mt-4 ">
                            {" "}
                            Quantity{" "}
                            <i
                              className="bx bx-info-circle"
                              title={product?.maxQty? `You can order this product with minimum quantity of ${product?.minQty}, \nmaximum quantity of ${product?.maxQty} in a lot size(multiple) of ${product.lotSize || 1}` : "No limit is set for this product"}
                            ></i>{" "}
                            :{" "}
                          </b>
                          <div className="mt-3 mb-2">
                            <div
                              style={{
                                width: "150px",
                                margin: "auto",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                                className="input-group"
                              >
                                <div className="input-group-prepend">
                                  <button
                                    type="button"
                                    className="btn"
                                    style={{ border: "none", fontSize: "20px" }}
                                    disabled={productWithInfo.isInCart}
                                    onClick={() => {
                                      setSelectedQuantity(
                                        Math.max(
                                          0,
                                          +selectedQuantity -
                                            (product?.lotSize
                                              ? +product?.lotSize
                                              : 1)
                                        )
                                      )
                                    }}
                                  >
                                    -
                                  </button>
                                </div>
                                <Input
                                  type="text"
                                  value={selectedQuantity}
                                  name="demo_vertical"
                                  className="text-center"
                                  disabled={productWithInfo.isInCart}
                                  onChange={e => {
                                    let value = parseInt(e.target.value)
                                    setSelectedQuantity(
                                      isNaN(value) ? 0 : value
                                    )
                                   
                                  }}
                                />
                                <div className="input-group-append">
                                  <button
                                    type="button"
                                    style={{ border: "none", fontSize: "20px" }}
                                    className="btn"
                                    disabled={productWithInfo.isInCart}
                                    onClick={() => {
                                      setSelectedQuantity(
                                        +selectedQuantity +
                                          (product?.lotSize
                                            ? +product?.lotSize
                                            : 1)
                                      )
                                    }}
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {!!product.isOffer && (
                        <h6 className="text-success text-uppercase">
                          {product?.offer} % Off
                        </h6>
                      )}
                      <p className="mb-2">
                        <b>Model : </b>
                        <span className="text-muted me-2">{modelList.join(", ")}</span>
                      </p>
                      <p className="mb-2">
                        <b>Base Unit : </b>
                        <span className="text-muted me-2">
                          {product?.baseUnit}
                        </span>
                      </p>
                      <p className="mb-2">
                        <b>Price : </b>
                        <span className="text-muted me-2">
                          {formatNumberWithCommas(product?.sellingPrice)}
                        </span>
                      </p>
                      {roleName !== "dealer" && <><p className="mb-2">
                        <b>Created on : </b>
                        <span className="text-muted me-2">
                          {moment(product?.createdAt).format("DD-MMM-YYYY")}
                        </span>
                      </p><p className="mb-2">
                          <b>Last Change on : </b>
                          <span className="text-muted me-2">
                            {moment(product?.updatedAt).format("DD-MMM-YYYY")}
                          </span>
                        </p></>
                      }
                      <p className="text-muted mb-2">
                        <b>Product Code :</b>
                        <span className="text-muted me-2">
                          {product?.productCode || " NA"}
                        </span>
                      </p>
                      <p className="text-muted mb-2">
                        <b>Description : </b>
                        <span className="text-muted me-2">
                          {product?.productDescription}
                        </span>
                      </p>

                      <></>
                      <div className="mt-4">
                        {roleName === "dealer" && (
                          <div className="text-left">
                            <>
                              <Button
                                type="button"
                                color="primary"
                                className="btn mt-2 me-1"
                                style={{
                                  backgroundColor: "#344fa0",
                                  border: "none",
                                }}
                                disabled={productWithInfo.isInCart}
                                onClick={() => {
                                  addToCart(product.id,product?.minQty,product?.maxQty,product?.lotSize)
                                }}
                              >
                                <i className="bx bx-cart me-2" />
                                {productWithInfo.isInCart
                                  ? "Added to cart"
                                  : "Add to cart"}
                              </Button>
                            </>
                            <Button
                              type="button"
                              color="info"
                              className="ms-1 btn mt-2"
                              style={{
                                backgroundColor: "#f1b44c",
                                border: "none",
                              }}
                              disabled={productWithInfo.isInWishList}
                              onClick={() => {
                                addToWishlist(product.id)
                              }}
                            >
                              <i className="bx bx-heart me-2" />
                              {productWithInfo.isInWishList
                                ? "Added to wishlist"
                                : "Add to wishlist"}
                            </Button>
                          </div>
                        )}
                        <div className="text-sm-end">
                          <Button
                            type="button"
                            outline
                            color="secondary"
                            className="btn mt-0 me-1 "
                            onClick={backButton}
                          >
                            Back
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </Container>

        <ToastDialog
          message={toastInfo.message}
          showToast={toastInfo.showToast}
          role={toastInfo.role}
          onCloseFn={() => setToastInfo({ showToast: false })}
        />
      </div>
      {lightbox && <Lightbox productData={product} setLightbox={setLightbox} />}
    </>
  )
}

EcommerceProductDetail.propTypes = {
  product: PropTypes.object,
  match: PropTypes.any,
  onGetProductDetail: PropTypes.func,
}

export default withRouter(EcommerceProductDetail)
